// import EntypoIcon from '@expo/vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUIStoreWebsiteCreateOptionsOrderView from 'xui/modules/storeWebsite/BaseUIStoreWebsiteCreateOptionsOrderView'

export default class StoreWebsiteCreateOptionsOrderView extends BaseUIStoreWebsiteCreateOptionsOrderView {}
